var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.753,17.2,0,22l4.817-2.753.021-.129,3.613-3.591,3.269,3.248q.9.9,2.043-.215V14.71l5.548-5.763.28.258a1.327,1.327,0,0,0,1,.43,1.433,1.433,0,0,0,1.43-1.43,1.43,1.43,0,0,0-.409-1.022L14.817.409A1.433,1.433,0,0,0,13.8,0a1.4,1.4,0,0,0-1.011.409,1.345,1.345,0,0,0-.42,1A1.392,1.392,0,0,0,12.8,2.43l.28.28L7.29,8.258l-3.849.021Q2.323,9.4,3.248,10.3l3.247,3.247L2.882,17.161Z","fill":"currentColor"}));
}

Pin.defaultProps = {"width":"22.021","height":"22","viewBox":"0 0 22.021 22"};

module.exports = Pin;

Pin.default = Pin;
